function toIsbn10(isbn) {
  return isbn.substr(isbn.length - 10);
}
function toIsbn13(isbn) {
  return `978${toIsbn10(isbn)}`;
}

export { toIsbn10, toIsbn13 };
//# sourceMappingURL=util.to-isbn.js.map
